declare namespace $ {

	export class $exso_sheets_plans_class extends $exso_sheets {
		paths( ): readonly(any)[]
		order_by( ): readonly(any)[]
		columns( ): ({ 
			'blast': ({ 
				'title': string,
				'unit': string,
			}) ,
			'burnt': ({ 
				'title': string,
				'unit': string,
			}) ,
		}) 
	}
	
}

//# sourceMappingURL=plans.view.tree.d.ts.map